export const OBJECTS_ADDED = 'OBJECTS_ADDED'
export const OBJECTS_EDITED = 'OBJECTS_EDITED'
export const OBJECT_SELECTED_REMOVED = 'OBJECT_SELECTED_REMOVED'



// WEBPACK FOOTER //
// ./src/store/objects/objects.constants.js